import { useState } from 'react';
import classNames from 'classnames';

import { pathToURL } from '@/utils/urls';

import * as styles from './styles.module.scss';

interface LevelBadgeProps {
    imagePath?: string;
    isLoading?: boolean;
    isLocked?: boolean;
    classname?: string;
    shimmerDelay?: number;
}

export default function LevelBadge({ imagePath, isLoading, isLocked, classname, shimmerDelay = 0 }: LevelBadgeProps) {
    const [imageIsLoading, setImageIsLoading] = useState(true);
    const shouldShowPlaceholder = isLoading || imageIsLoading;
    const imageUrl = imagePath ? pathToURL(imagePath) : '';

    const handleImageLoad = () => {
        setImageIsLoading(false);
    };

    // Once loaded, show padlock icon if locked
    if (!isLoading && isLocked) {
        return (
            <div className={classNames(styles.LevelBadge, classname)}>
                <svg
                    className={styles.image}
                    width="127"
                    height="111"
                    viewBox="0 0 127 111"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z"
                        fill="#4E4E4E"
                    />
                    <path
                        d="M85.8068 55.3966L85.6556 51.8232C84.9669 50.9671 84.4713 50.355 83.7825 49.4989L80.5529 48.6097L80.7209 48.0969L82.0858 43.8783L82.4932 38.6754L80.8973 33.6959L77.3737 29.8289L72.6994 27.5087L67.4832 27L62.5065 28.6378L58.4874 31.9465L55.8499 36.471L54.6698 40.7475L54.5606 41.1321L51.499 40.2801C50.4364 40.6855 49.6931 40.9667 48.6263 41.372L46.6986 44.4077L43.3976 48.8496L45.7873 54.5322L44.4224 58.6763L43.2422 62.8163L41.4699 63.6765L40 67.9737L43.3598 71.3444L46.56 74.8309L49.7057 78.3711L52.9101 81.8535L56.1607 82.8254L56.9586 83.0612L60.2429 84L64.8122 82.6186L69.4655 81.5433L74.0097 80.0792L78.6294 78.8633L79.6962 74.4752L78.8184 72.8209L79.9187 68.6974L81.0107 64.4913L86 60.86L85.8068 55.4007V55.3966ZM66.0217 61.4928L64.7786 71.2782L55.8625 68.7595L60.0749 59.8137L57.6558 55.5165L65.8411 51.0457L70.3811 59.1064L66.0175 61.4887L66.0217 61.4928ZM75.908 43.3696L74.837 47.0257L73.8711 46.7569L68.0502 44.966L67.2775 44.6434L61.3558 43.2125L60.6166 42.985L61.7254 39.2958C61.9396 38.5886 62.2839 37.9269 62.7459 37.3437L64.4384 35.2096C65.0978 34.3742 66.0721 33.8365 67.1389 33.7083L69.4151 33.4395C70.4525 33.3154 71.4982 33.5925 72.334 34.2129L74.1903 35.5901C75.0722 36.2436 75.6434 37.2238 75.7736 38.2991L76.1012 41.0577C76.1936 41.8352 76.1264 42.6252 75.908 43.3779V43.3696Z"
                        fill="#1D1D1D"
                    />
                </svg>
            </div>
        );
    }
    return (
        <div className={classNames(styles.LevelBadge, classname)}>
            <img
                className={classNames(styles.image, { [styles.hidden]: shouldShowPlaceholder })}
                src={imageUrl}
                alt=" "
                crossOrigin="anonymous"
                onLoad={handleImageLoad}
            />
            <svg
                className={classNames(styles.image, styles.placeholder, {
                    [styles.hidden]: !shouldShowPlaceholder,
                })}
                width="127"
                height="111"
                viewBox="0 0 127 111"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z"
                    fill="#1B1B1B"
                />
            </svg>
            <div className={styles.shiny} style={{ maskImage: `url(${imageUrl})` }}>
                <div style={{ animationDelay: `${shimmerDelay * 2}s` }} />
            </div>
        </div>
    );
}
